import mutations from './mutations'
import actions from './actions'
import getters from './getters'

export default {
  namespaced: true,
  state: {
    selections: [],
    lifeSelections: []
  },
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/Osm/Renewal/store/index.js